{
  "address": "FarmsPZpWu9i7Kky8tPN37rs2TpmMrAZrC7S7vJa91Hr",
  "metadata": {
    "name": "farms",
    "version": "0.1.0",
    "spec": "0.1.0"
  },
  "instructions": [
    {
      "name": "initialize_global_config",
      "discriminator": [113, 216, 122, 131, 225, 209, 22, 55],
      "accounts": [
        {
          "name": "global_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "global_config",
          "writable": true
        },
        {
          "name": "treasury_vaults_authority"
        },
        {
          "name": "system_program"
        }
      ],
      "args": []
    },
    {
      "name": "update_global_config",
      "discriminator": [164, 84, 130, 189, 111, 58, 250, 200],
      "accounts": [
        {
          "name": "global_admin",
          "signer": true
        },
        {
          "name": "global_config",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "mode",
          "type": "u8"
        },
        {
          "name": "value",
          "type": {
            "array": ["u8", 32]
          }
        }
      ]
    },
    {
      "name": "initialize_farm",
      "discriminator": [252, 28, 185, 172, 244, 74, 117, 165],
      "accounts": [
        {
          "name": "farm_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "global_config"
        },
        {
          "name": "farm_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "token_mint"
        },
        {
          "name": "token_program"
        },
        {
          "name": "system_program"
        },
        {
          "name": "rent"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_farm_delegated",
      "discriminator": [250, 84, 101, 25, 51, 77, 204, 91],
      "accounts": [
        {
          "name": "farm_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_delegate",
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "global_config"
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "system_program"
        },
        {
          "name": "rent"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_reward",
      "discriminator": [95, 135, 192, 196, 242, 129, 230, 68],
      "accounts": [
        {
          "name": "farm_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "global_config"
        },
        {
          "name": "reward_mint"
        },
        {
          "name": "reward_vault",
          "writable": true
        },
        {
          "name": "reward_treasury_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "treasury_vaults_authority"
        },
        {
          "name": "token_program"
        },
        {
          "name": "system_program"
        },
        {
          "name": "rent"
        }
      ],
      "args": []
    },
    {
      "name": "add_rewards",
      "discriminator": [88, 186, 25, 227, 38, 137, 81, 23],
      "accounts": [
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "reward_mint"
        },
        {
          "name": "reward_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "payer_reward_token_ata",
          "writable": true
        },
        {
          "name": "scope_prices",
          "optional": true
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        },
        {
          "name": "reward_index",
          "type": "u64"
        }
      ]
    },
    {
      "name": "update_farm_config",
      "discriminator": [214, 176, 188, 244, 203, 59, 230, 207],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "scope_prices",
          "optional": true
        }
      ],
      "args": [
        {
          "name": "mode",
          "type": "u16"
        },
        {
          "name": "data",
          "type": "bytes"
        }
      ]
    },
    {
      "name": "initialize_user",
      "discriminator": [111, 17, 185, 250, 60, 122, 38, 254],
      "accounts": [
        {
          "name": "authority",
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "owner"
        },
        {
          "name": "delegatee"
        },
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "system_program"
        },
        {
          "name": "rent"
        }
      ],
      "args": []
    },
    {
      "name": "transfer_ownership",
      "discriminator": [65, 177, 215, 73, 53, 45, 99, 47],
      "accounts": [
        {
          "name": "owner",
          "signer": true
        },
        {
          "name": "user_state",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "new_owner",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "reward_user_once",
      "discriminator": [219, 137, 57, 22, 94, 186, 96, 114],
      "accounts": [
        {
          "name": "farm_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "user_state",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "reward_index",
          "type": "u64"
        },
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "refresh_farm",
      "discriminator": [214, 131, 138, 183, 144, 194, 172, 42],
      "accounts": [
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "scope_prices",
          "optional": true
        }
      ],
      "args": []
    },
    {
      "name": "stake",
      "discriminator": [206, 176, 202, 18, 200, 209, 179, 108],
      "accounts": [
        {
          "name": "owner",
          "signer": true
        },
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "farm_vault",
          "writable": true
        },
        {
          "name": "user_ata",
          "writable": true
        },
        {
          "name": "token_mint"
        },
        {
          "name": "scope_prices",
          "optional": true
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_stake_delegated",
      "discriminator": [73, 171, 184, 75, 30, 56, 198, 223],
      "accounts": [
        {
          "name": "delegate_authority",
          "signer": true
        },
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "new_amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "harvest_reward",
      "discriminator": [68, 200, 228, 233, 184, 32, 226, 188],
      "accounts": [
        {
          "name": "owner",
          "writable": true,
          "signer": true
        },
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "global_config"
        },
        {
          "name": "reward_mint"
        },
        {
          "name": "user_reward_ata",
          "writable": true
        },
        {
          "name": "rewards_vault",
          "writable": true
        },
        {
          "name": "rewards_treasury_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "scope_prices",
          "optional": true
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "reward_index",
          "type": "u64"
        }
      ]
    },
    {
      "name": "unstake",
      "discriminator": [90, 95, 107, 42, 205, 124, 50, 225],
      "accounts": [
        {
          "name": "owner",
          "writable": true,
          "signer": true
        },
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "scope_prices",
          "optional": true
        }
      ],
      "args": [
        {
          "name": "stake_shares_scaled",
          "type": "u128"
        }
      ]
    },
    {
      "name": "refresh_user_state",
      "discriminator": [1, 135, 12, 62, 243, 140, 77, 108],
      "accounts": [
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "scope_prices",
          "optional": true
        }
      ],
      "args": []
    },
    {
      "name": "withdraw_unstaked_deposits",
      "discriminator": [36, 102, 187, 49, 220, 36, 132, 67],
      "accounts": [
        {
          "name": "owner",
          "writable": true,
          "signer": true
        },
        {
          "name": "user_state",
          "writable": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "user_ata",
          "writable": true
        },
        {
          "name": "farm_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "token_program"
        }
      ],
      "args": []
    },
    {
      "name": "withdraw_treasury",
      "discriminator": [40, 63, 122, 158, 144, 216, 83, 96],
      "accounts": [
        {
          "name": "global_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "global_config"
        },
        {
          "name": "reward_mint"
        },
        {
          "name": "reward_treasury_vault",
          "writable": true
        },
        {
          "name": "treasury_vault_authority"
        },
        {
          "name": "withdraw_destination_token_account",
          "writable": true
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "deposit_to_farm_vault",
      "discriminator": [131, 166, 64, 94, 108, 213, 114, 183],
      "accounts": [
        {
          "name": "depositor",
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "farm_vault",
          "writable": true
        },
        {
          "name": "depositor_ata",
          "writable": true
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "withdraw_from_farm_vault",
      "discriminator": [22, 82, 128, 250, 86, 79, 124, 78],
      "accounts": [
        {
          "name": "withdraw_authority",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "withdrawer_token_account",
          "writable": true
        },
        {
          "name": "farm_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "withdraw_slashed_amount",
      "discriminator": [202, 217, 67, 74, 172, 22, 140, 216],
      "accounts": [
        {
          "name": "crank",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "slashed_amount_spill_address",
          "writable": true
        },
        {
          "name": "farm_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "token_program"
        }
      ],
      "args": []
    },
    {
      "name": "update_farm_admin",
      "discriminator": [20, 37, 136, 19, 122, 239, 36, 130],
      "accounts": [
        {
          "name": "pending_farm_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        }
      ],
      "args": []
    },
    {
      "name": "update_global_config_admin",
      "discriminator": [184, 87, 23, 193, 156, 238, 175, 119],
      "accounts": [
        {
          "name": "pending_global_admin",
          "signer": true
        },
        {
          "name": "global_config",
          "writable": true
        }
      ],
      "args": []
    },
    {
      "name": "withdraw_reward",
      "discriminator": [191, 187, 176, 137, 9, 25, 187, 244],
      "accounts": [
        {
          "name": "farm_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "reward_mint"
        },
        {
          "name": "reward_vault",
          "writable": true
        },
        {
          "name": "farm_vaults_authority"
        },
        {
          "name": "admin_reward_token_ata",
          "writable": true
        },
        {
          "name": "scope_prices",
          "optional": true
        },
        {
          "name": "token_program"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        },
        {
          "name": "reward_index",
          "type": "u64"
        }
      ]
    },
    {
      "name": "update_second_delegated_authority",
      "discriminator": [127, 26, 6, 181, 203, 248, 117, 64],
      "accounts": [
        {
          "name": "global_admin",
          "writable": true,
          "signer": true
        },
        {
          "name": "farm_state",
          "writable": true
        },
        {
          "name": "global_config"
        },
        {
          "name": "new_second_delegated_authority"
        }
      ],
      "args": []
    },
    {
      "name": "idl_missing_types",
      "discriminator": [130, 80, 38, 153, 80, 212, 182, 253],
      "accounts": [
        {
          "name": "global_admin",
          "signer": true
        },
        {
          "name": "global_config",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "global_config_option_kind",
          "type": {
            "defined": {
              "name": "GlobalConfigOption"
            }
          }
        },
        {
          "name": "farm_config_option_kind",
          "type": {
            "defined": {
              "name": "FarmConfigOption"
            }
          }
        },
        {
          "name": "time_unit",
          "type": {
            "defined": {
              "name": "TimeUnit"
            }
          }
        },
        {
          "name": "locking_mode",
          "type": {
            "defined": {
              "name": "LockingMode"
            }
          }
        },
        {
          "name": "reward_type",
          "type": {
            "defined": {
              "name": "RewardType"
            }
          }
        }
      ]
    }
  ],
  "accounts": [
    {
      "name": "FarmState",
      "discriminator": [198, 102, 216, 74, 63, 66, 163, 190]
    },
    {
      "name": "GlobalConfig",
      "discriminator": [149, 8, 156, 202, 160, 252, 176, 217]
    },
    {
      "name": "UserState",
      "discriminator": [72, 177, 85, 249, 76, 167, 186, 126]
    },
    {
      "name": "OraclePrices",
      "discriminator": [89, 128, 118, 221, 6, 72, 180, 146]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "StakeZero",
      "msg": "Cannot stake 0 amount"
    },
    {
      "code": 6001,
      "name": "UnstakeZero",
      "msg": "Cannot unstake 0 amount"
    },
    {
      "code": 6002,
      "name": "NothingToUnstake",
      "msg": "Nothing to unstake"
    },
    {
      "code": 6003,
      "name": "NoRewardToHarvest",
      "msg": "No reward to harvest"
    },
    {
      "code": 6004,
      "name": "NoRewardInList",
      "msg": "Reward not present in reward list"
    },
    {
      "code": 6005,
      "name": "RewardAlreadyInitialized",
      "msg": "Reward already initialized"
    },
    {
      "code": 6006,
      "name": "MaxRewardNumberReached",
      "msg": "Max number of reward tokens reached"
    },
    {
      "code": 6007,
      "name": "RewardDoesNotExist",
      "msg": "Reward does not exist"
    },
    {
      "code": 6008,
      "name": "WrongRewardVaultAccount",
      "msg": "Reward vault exists but the account is wrong"
    },
    {
      "code": 6009,
      "name": "RewardVaultMismatch",
      "msg": "Reward vault pubkey does not match staking pool vault"
    },
    {
      "code": 6010,
      "name": "RewardVaultAuthorityMismatch",
      "msg": "Reward vault authority pubkey does not match staking pool vault"
    },
    {
      "code": 6011,
      "name": "NothingStaked",
      "msg": "Nothing staked, cannot collect any rewards"
    },
    {
      "code": 6012,
      "name": "IntegerOverflow",
      "msg": "Integer overflow"
    },
    {
      "code": 6013,
      "name": "ConversionFailure",
      "msg": "Conversion failure"
    },
    {
      "code": 6014,
      "name": "UnexpectedAccount",
      "msg": "Unexpected account in instruction"
    },
    {
      "code": 6015,
      "name": "OperationForbidden",
      "msg": "Operation forbidden"
    },
    {
      "code": 6016,
      "name": "MathOverflow",
      "msg": "Mathematical operation with overflow"
    },
    {
      "code": 6017,
      "name": "MinClaimDurationNotReached",
      "msg": "Minimum claim duration has not been reached"
    },
    {
      "code": 6018,
      "name": "RewardsVaultHasDelegate",
      "msg": "Reward vault has a delegate"
    },
    {
      "code": 6019,
      "name": "RewardsVaultHasCloseAuthority",
      "msg": "Reward vault has a close authority"
    },
    {
      "code": 6020,
      "name": "FarmVaultHasDelegate",
      "msg": "Farm vault has a delegate"
    },
    {
      "code": 6021,
      "name": "FarmVaultHasCloseAuthority",
      "msg": "Farm vault has a close authority"
    },
    {
      "code": 6022,
      "name": "RewardsTreasuryVaultHasDelegate",
      "msg": "Reward vault has a delegate"
    },
    {
      "code": 6023,
      "name": "RewardsTreasuryVaultHasCloseAuthority",
      "msg": "Reward vault has a close authority"
    },
    {
      "code": 6024,
      "name": "UserAtaRewardVaultMintMissmatch",
      "msg": "User ata and reward vault have different mints"
    },
    {
      "code": 6025,
      "name": "UserAtaFarmTokenMintMissmatch",
      "msg": "User ata and farm token have different mints"
    },
    {
      "code": 6026,
      "name": "TokenFarmTokenMintMissmatch",
      "msg": "Token mint and farm token have different mints"
    },
    {
      "code": 6027,
      "name": "RewardAtaRewardMintMissmatch",
      "msg": "Reward ata mint is different than reward mint"
    },
    {
      "code": 6028,
      "name": "RewardAtaOwnerNotPayer",
      "msg": "Reward ata owner is different than payer"
    },
    {
      "code": 6029,
      "name": "InvalidGlobalConfigMode",
      "msg": "Mode to update global_config is invalid"
    },
    {
      "code": 6030,
      "name": "RewardIndexOutOfRange",
      "msg": "Reward Index is higher than number of rewards"
    },
    {
      "code": 6031,
      "name": "NothingToWithdraw",
      "msg": "No tokens available to withdraw"
    },
    {
      "code": 6032,
      "name": "UserDelegatedFarmNonDelegatedMissmatch",
      "msg": "user, user_ref, authority and payer must match for non-delegated farm"
    },
    {
      "code": 6033,
      "name": "AuthorityFarmDelegateMissmatch",
      "msg": "Authority must match farm delegate authority"
    },
    {
      "code": 6034,
      "name": "FarmNotDelegated",
      "msg": "Farm not delegated, can not set stake"
    },
    {
      "code": 6035,
      "name": "FarmDelegated",
      "msg": "Operation not allowed for delegated farm"
    },
    {
      "code": 6036,
      "name": "UnstakeNotElapsed",
      "msg": "Unstake lockup period is not elapsed. Deposit is locked until end of unstake period"
    },
    {
      "code": 6037,
      "name": "PendingWithdrawalNotWithdrawnYet",
      "msg": "Pending withdrawal already exist and not withdrawn yet"
    },
    {
      "code": 6038,
      "name": "DepositZero",
      "msg": "Cannot deposit zero amount directly to farm vault"
    },
    {
      "code": 6039,
      "name": "InvalidConfigValue",
      "msg": "Invalid config value"
    },
    {
      "code": 6040,
      "name": "InvalidPenaltyPercentage",
      "msg": "Invalid penalty percentage"
    },
    {
      "code": 6041,
      "name": "EarlyWithdrawalNotAllowed",
      "msg": "Early withdrawal not allowed"
    },
    {
      "code": 6042,
      "name": "InvalidLockingTimestamps",
      "msg": "Invalid locking timestamps"
    },
    {
      "code": 6043,
      "name": "InvalidRpsCurvePoint",
      "msg": "Invalid reward rate curve point"
    },
    {
      "code": 6044,
      "name": "InvalidTimestamp",
      "msg": "Invalid timestamp"
    },
    {
      "code": 6045,
      "name": "DepositCapReached",
      "msg": "Deposit cap reached"
    },
    {
      "code": 6046,
      "name": "MissingScopePrices",
      "msg": "Missing Scope Prices"
    },
    {
      "code": 6047,
      "name": "ScopeOraclePriceTooOld",
      "msg": "Scope Oracle Price Too Old"
    },
    {
      "code": 6048,
      "name": "InvalidOracleConfig",
      "msg": "Invalid Oracle Config"
    },
    {
      "code": 6049,
      "name": "CouldNotDeserializeScope",
      "msg": "Could not deserialize scope"
    },
    {
      "code": 6050,
      "name": "RewardAtaOwnerNotAdmin",
      "msg": "Reward ata owner is different than farm admin"
    },
    {
      "code": 6051,
      "name": "WithdrawRewardZeroAvailable",
      "msg": "Cannot withdraw reward as available amount is zero"
    },
    {
      "code": 6052,
      "name": "RewardScheduleCurveSet",
      "msg": "Cannot withdraw reward as reward schedule is set"
    },
    {
      "code": 6053,
      "name": "UnsupportedTokenExtension",
      "msg": "Cannot initialize farm while having a mint with token22 and requested extensions"
    },
    {
      "code": 6054,
      "name": "InvalidFarmConfigUpdateAuthority",
      "msg": "Invalid authority for updating farm config"
    }
  ],
  "types": [
    {
      "name": "FarmConfigOption",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "UpdateRewardRps"
          },
          {
            "name": "UpdateRewardMinClaimDuration"
          },
          {
            "name": "WithdrawAuthority"
          },
          {
            "name": "DepositWarmupPeriod"
          },
          {
            "name": "WithdrawCooldownPeriod"
          },
          {
            "name": "RewardType"
          },
          {
            "name": "RpsDecimals"
          },
          {
            "name": "LockingMode"
          },
          {
            "name": "LockingStartTimestamp"
          },
          {
            "name": "LockingDuration"
          },
          {
            "name": "LockingEarlyWithdrawalPenaltyBps"
          },
          {
            "name": "DepositCapAmount"
          },
          {
            "name": "SlashedAmountSpillAddress"
          },
          {
            "name": "ScopePricesAccount"
          },
          {
            "name": "ScopeOraclePriceId"
          },
          {
            "name": "ScopeOracleMaxAge"
          },
          {
            "name": "UpdateRewardScheduleCurvePoints"
          },
          {
            "name": "UpdatePendingFarmAdmin"
          },
          {
            "name": "UpdateStrategyId"
          },
          {
            "name": "UpdateDelegatedRpsAdmin"
          },
          {
            "name": "UpdateVaultId"
          },
          {
            "name": "UpdateExtraDelegatedAuthority"
          }
        ]
      }
    },
    {
      "name": "GlobalConfigOption",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "SetPendingGlobalAdmin"
          },
          {
            "name": "SetTreasuryFeeBps"
          }
        ]
      }
    },
    {
      "name": "LockingMode",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "None"
          },
          {
            "name": "Continuous"
          },
          {
            "name": "WithExpiry"
          }
        ]
      }
    },
    {
      "name": "RewardInfo",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "token",
            "type": {
              "defined": {
                "name": "TokenInfo"
              }
            }
          },
          {
            "name": "rewards_vault",
            "type": "pubkey"
          },
          {
            "name": "rewards_available",
            "type": "u64"
          },
          {
            "name": "reward_schedule_curve",
            "type": {
              "defined": {
                "name": "RewardScheduleCurve"
              }
            }
          },
          {
            "name": "min_claim_duration_seconds",
            "type": "u64"
          },
          {
            "name": "last_issuance_ts",
            "type": "u64"
          },
          {
            "name": "rewards_issued_unclaimed",
            "type": "u64"
          },
          {
            "name": "rewards_issued_cumulative",
            "type": "u64"
          },
          {
            "name": "reward_per_share_scaled",
            "type": "u128"
          },
          {
            "name": "placeholder0",
            "type": "u64"
          },
          {
            "name": "reward_type",
            "type": "u8"
          },
          {
            "name": "rewards_per_second_decimals",
            "type": "u8"
          },
          {
            "name": "padding0",
            "type": {
              "array": ["u8", 6]
            }
          },
          {
            "name": "padding1",
            "type": {
              "array": ["u64", 20]
            }
          }
        ]
      }
    },
    {
      "name": "RewardPerTimeUnitPoint",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "ts_start",
            "type": "u64"
          },
          {
            "name": "reward_per_time_unit",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "RewardScheduleCurve",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "points",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "RewardPerTimeUnitPoint"
                  }
                },
                20
              ]
            }
          }
        ]
      }
    },
    {
      "name": "RewardType",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "Proportional"
          },
          {
            "name": "Constant"
          }
        ]
      }
    },
    {
      "name": "TimeUnit",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "Seconds"
          },
          {
            "name": "Slots"
          }
        ]
      }
    },
    {
      "name": "TokenInfo",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "decimals",
            "type": "u64"
          },
          {
            "name": "token_program",
            "type": "pubkey"
          },
          {
            "name": "padding",
            "type": {
              "array": ["u64", 6]
            }
          }
        ]
      }
    },
    {
      "name": "DatedPrice",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "price",
            "type": {
              "defined": {
                "name": "Price"
              }
            }
          },
          {
            "name": "last_updated_slot",
            "type": "u64"
          },
          {
            "name": "unix_timestamp",
            "type": "u64"
          },
          {
            "name": "reserved",
            "type": {
              "array": ["u64", 2]
            }
          },
          {
            "name": "reserved2",
            "type": {
              "array": ["u16", 3]
            }
          },
          {
            "name": "index",
            "type": "u16"
          }
        ]
      }
    },
    {
      "name": "Price",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "value",
            "type": "u64"
          },
          {
            "name": "exp",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "FarmState",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "farm_admin",
            "type": "pubkey"
          },
          {
            "name": "global_config",
            "type": "pubkey"
          },
          {
            "name": "token",
            "type": {
              "defined": {
                "name": "TokenInfo"
              }
            }
          },
          {
            "name": "reward_infos",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "RewardInfo"
                  }
                },
                10
              ]
            }
          },
          {
            "name": "num_reward_tokens",
            "type": "u64"
          },
          {
            "name": "num_users",
            "type": "u64"
          },
          {
            "name": "total_staked_amount",
            "type": "u64"
          },
          {
            "name": "farm_vault",
            "type": "pubkey"
          },
          {
            "name": "farm_vaults_authority",
            "type": "pubkey"
          },
          {
            "name": "farm_vaults_authority_bump",
            "type": "u64"
          },
          {
            "name": "delegate_authority",
            "type": "pubkey"
          },
          {
            "name": "time_unit",
            "type": "u8"
          },
          {
            "name": "is_farm_frozen",
            "type": "u8"
          },
          {
            "name": "is_farm_delegated",
            "type": "u8"
          },
          {
            "name": "padding0",
            "type": {
              "array": ["u8", 5]
            }
          },
          {
            "name": "withdraw_authority",
            "type": "pubkey"
          },
          {
            "name": "deposit_warmup_period",
            "type": "u32"
          },
          {
            "name": "withdrawal_cooldown_period",
            "type": "u32"
          },
          {
            "name": "total_active_stake_scaled",
            "type": "u128"
          },
          {
            "name": "total_pending_stake_scaled",
            "type": "u128"
          },
          {
            "name": "total_pending_amount",
            "type": "u64"
          },
          {
            "name": "slashed_amount_current",
            "type": "u64"
          },
          {
            "name": "slashed_amount_cumulative",
            "type": "u64"
          },
          {
            "name": "slashed_amount_spill_address",
            "type": "pubkey"
          },
          {
            "name": "locking_mode",
            "type": "u64"
          },
          {
            "name": "locking_start_timestamp",
            "type": "u64"
          },
          {
            "name": "locking_duration",
            "type": "u64"
          },
          {
            "name": "locking_early_withdrawal_penalty_bps",
            "type": "u64"
          },
          {
            "name": "deposit_cap_amount",
            "type": "u64"
          },
          {
            "name": "scope_prices",
            "type": "pubkey"
          },
          {
            "name": "scope_oracle_price_id",
            "type": "u64"
          },
          {
            "name": "scope_oracle_max_age",
            "type": "u64"
          },
          {
            "name": "pending_farm_admin",
            "type": "pubkey"
          },
          {
            "name": "strategy_id",
            "type": "pubkey"
          },
          {
            "name": "delegated_rps_admin",
            "type": "pubkey"
          },
          {
            "name": "vault_id",
            "type": "pubkey"
          },
          {
            "name": "second_delegated_authority",
            "type": "pubkey"
          },
          {
            "name": "padding",
            "type": {
              "array": ["u64", 74]
            }
          }
        ]
      }
    },
    {
      "name": "GlobalConfig",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "global_admin",
            "type": "pubkey"
          },
          {
            "name": "treasury_fee_bps",
            "type": "u64"
          },
          {
            "name": "treasury_vaults_authority",
            "type": "pubkey"
          },
          {
            "name": "treasury_vaults_authority_bump",
            "type": "u64"
          },
          {
            "name": "pending_global_admin",
            "type": "pubkey"
          },
          {
            "name": "padding1",
            "type": {
              "array": ["u128", 126]
            }
          }
        ]
      }
    },
    {
      "name": "UserState",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "user_id",
            "type": "u64"
          },
          {
            "name": "farm_state",
            "type": "pubkey"
          },
          {
            "name": "owner",
            "type": "pubkey"
          },
          {
            "name": "is_farm_delegated",
            "type": "u8"
          },
          {
            "name": "padding0",
            "type": {
              "array": ["u8", 7]
            }
          },
          {
            "name": "rewards_tally_scaled",
            "type": {
              "array": ["u128", 10]
            }
          },
          {
            "name": "rewards_issued_unclaimed",
            "type": {
              "array": ["u64", 10]
            }
          },
          {
            "name": "last_claim_ts",
            "type": {
              "array": ["u64", 10]
            }
          },
          {
            "name": "active_stake_scaled",
            "type": "u128"
          },
          {
            "name": "pending_deposit_stake_scaled",
            "type": "u128"
          },
          {
            "name": "pending_deposit_stake_ts",
            "type": "u64"
          },
          {
            "name": "pending_withdrawal_unstake_scaled",
            "type": "u128"
          },
          {
            "name": "pending_withdrawal_unstake_ts",
            "type": "u64"
          },
          {
            "name": "bump",
            "type": "u64"
          },
          {
            "name": "delegatee",
            "type": "pubkey"
          },
          {
            "name": "last_stake_ts",
            "type": "u64"
          },
          {
            "name": "padding1",
            "type": {
              "array": ["u64", 50]
            }
          }
        ]
      }
    },
    {
      "name": "OraclePrices",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "oracle_mappings",
            "type": "pubkey"
          },
          {
            "name": "prices",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "DatedPrice"
                  }
                },
                512
              ]
            }
          }
        ]
      }
    }
  ]
}
